import * as types from '../constants/ActionTypes'

const initalState = {
  form: {},
}

const master = (state = initalState, action) => {

  switch (action.type) {
    case types.REDUCER_SUB_HOLIDAY_INIT:

      let workHolidayCount = 0;
      let subHolidayCount = 0;

      action.payload.list && action.payload.list.subHolidayContents.forEach(x => {

        if (x.workHolidayAll) workHolidayCount+=1;
        if (x.workHolidayHarf) workHolidayCount+=0.5;
        if (x.subHoliday1) subHolidayCount+=0.5;
        if (x.subHoliday2) subHolidayCount+=0.5;
        if (x.changeMoney == 4) subHolidayCount+=0.5;
        if (x.changeMoney == 8) subHolidayCount+=1;

      })

      const form =  {
        ...action.payload.list
      }

      const count = workHolidayCount - subHolidayCount;

      return Object.assign({}, state, {
        form,
        count
      })

    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/subHoliday.js